import {$http} from '@/utils/https'
import {
    CHANGE_CATEGORY,
    CHANGE_FROM_ROUTE_INFO,
    CHANGE_HEADER,
    CHANGE_LIST_LOADING,
    CHANGE_LOADING,
    CHANGE_LOADING_REPORT,
    CHANGE_LOADING_TEST,
    CHANGE_POPUP_CANCEL_TEST,
    CHANGE_STEP,
    SET_COMMENT,
    SET_CURRENT_QUESTION,
    SET_ITEM,
    SET_RATE,
    SET_REPORT_RESULT,
} from './types/mutation-types';

import {
    COMPLETE_QUESTION,
    COMPLETE_TEST,
    CREATE_RATE,
    GET_LIST_ITEM,
    GET_REPORT,
    SEND_COMMENT,
    SEND_COMMENT_FILE,
    START_TEST,
    UPDATE_RATE,
    UPDATE_RATE_COMMENT,
} from './types/action-types';


const state = {
    activeStep: 0,
    currentItem: null,
    isLoading: false,
    isLoadingTest: false,
    isLoadingReport: false,
    reportResult: null,

    activeCategory: '',
    currentTest: null,
    showPopupCancel: false,


    header: {
        show: false,
        title: '',
        currentTime: '',
        availableTime: '',
        parentRoute: ''
    },

    routeFromInfo: {
        name: '',
        params: {}
    },
    comment: null
};

const getters = {
    currentItem: state => state.currentItem,
    activeStep: state => state.activeStep,
    header: state => state.header,
    activeCategory: state => state.activeCategory,
    isLoading: state => state.isLoading,
    currentTest: state => state.currentTest,
    isLoadingTest: state => state.isLoadingTest,
    isLoadingReport: state => state.isLoadingReport,
    reportResult: state => state.reportResult,
    showPopupCancel: state => state.showPopupCancel,


    routeFromInfo: state => state.routeFromInfo,
    comment: state => state.comment
};

const modifySummary = (state, plus) => {
    if (state.reportResult.homeWork.data.userRating.data.rating) {
        const key = state.reportResult.homeWork.data.userRating.data.rating - 1;
        if (state.reportResult.homeWork.data.ratingSummary && state.reportResult.homeWork.data.ratingSummary.data[key]) {
            if (plus) {
                state.reportResult.homeWork.data.ratingSummary.data[key].count += 1;
            } else {
                state.reportResult.homeWork.data.ratingSummary.data[key].count -= 1;
            }
        }
    }
}

const actions = {
    [GET_LIST_ITEM]: async ({commit}, payload) => {
        try {
            commit(SET_ITEM, null);
            commit(CHANGE_LOADING, true);

            const response = await $http.get(`${process.env.VUE_APP_ROOT_COURSE}courses/${payload.item}/modules/${payload.moduleSlug}/home-works/${payload.testId}?include=files,userHomeWork,userHomeWork.comments.user,userHomeWork.retakingHistory.questions.question.answers.userAnswer&use_as_id=slug`);
            commit(SET_ITEM, response.data.data);
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_LOADING, false);
        }
    },
    [START_TEST]: async ({commit}, payload) => {
        try {
            commit(CHANGE_LOADING_TEST, true);

            const response = await $http.post(`${process.env.VUE_APP_ROOT_COURSE}courses/${payload.item}/modules/${payload.moduleSlug}/home-works/${payload.testId}/start?include=currentQuestion&use_as_id=slug`);
            commit(SET_CURRENT_QUESTION, response.data.data);
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_LOADING_TEST, false);
        }
    },
    [COMPLETE_QUESTION]: async ({commit}, payload) => {
        try {
            commit(CHANGE_LOADING_TEST, true);
            const response = await $http.post(`${process.env.VUE_APP_ROOT_COURSE}courses/${payload.get('item')}/modules/${payload.get('moduleSlug')}/home-works/${payload.get('testId')}/questions/${payload.get('id')}/complete?include=currentUserQuestion&use_as_id=slug`, payload);
            commit(SET_CURRENT_QUESTION, response.data.data);
            return response.data.data;
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_LOADING_TEST, false);
        }
    },
    [COMPLETE_TEST]: async ({commit}, payload) => {
        try {
            commit(CHANGE_LOADING_TEST, true);
            const response = await $http.post(`${process.env.VUE_APP_ROOT_COURSE}courses/${payload.get('item')}/modules/${payload.get('moduleSlug')}/home-works/${payload.get('testId')}/complete?include=&use_as_id=slug`, payload);
            commit(SET_CURRENT_QUESTION, response.data.data);
            return response.data.data;
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_LOADING_TEST, false);
        }
    },
    [GET_REPORT]: async ({commit}, payload) => {
        try {
            commit(CHANGE_LOADING_REPORT, true);

            const response = await $http.get(`${process.env.VUE_APP_ROOT_COURSE}courses/${payload.item}/modules/${payload.moduleSlug}/home-works/${payload.testId}/report?include=homeWork.userRating,homeWork.ratingSummary,questions.question.answers.userAnswer,questions.answers,retakingHistory.questions.question.answers.userAnswer&use_as_id=slug`, payload);
            commit(SET_REPORT_RESULT, response.data.data);
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_LOADING_REPORT, false);
        }
    },
    [SEND_COMMENT]: async ({commit}, payload) => {
        try {
            const response = await $http.post(`${process.env.VUE_APP_ROOT_COURSE}courses/${payload.item}/modules/${payload.moduleSlug}/home-works/${payload.testId}/comments?include=user&use_as_id=slug`, payload.comment);
            commit(SET_COMMENT, response.data.data);
            return response;
        } catch (e) {
            throw e;
        } finally {
        }
    },
    [SEND_COMMENT_FILE]: async ({commit}, payload) => {
        try {

            const response = await $http.post(`${process.env.VUE_APP_ROOT_COURSE}courses/${payload.item}/modules/${payload.moduleSlug}/home-works/${payload.testId}/comments?include=user&use_as_id=slug`, payload.file);
            return response;
        } catch (e) {
            throw e;
        } finally {
        }
    },
    [CREATE_RATE]: async (
        {commit},
        {courseId, moduleId, homeWorkId, rating},
    ) => {
        try {
            commit(SET_RATE, {data: {rating, comment: ''}, changeSummary: true});
            const {data} = await $http.post(
                `${process.env.VUE_APP_ROOT_COURSE}courses/${courseId}/modules/${moduleId}/home-works/${homeWorkId}/ratings`,
                {rating},
            );
            commit(SET_RATE, data);
        } catch (e) {
            throw e;
        }
    },
    [UPDATE_RATE]: async (
        {commit},
        {courseId, moduleId, homeWorkId, rateId, rating},
    ) => {
        try {
            commit(SET_RATE, {data: {rating, comment: ''}, changeSummary: true});
            const {data} = await $http.post(
                `${process.env.VUE_APP_ROOT_COURSE}courses/${courseId}/modules/${moduleId}/home-works/${homeWorkId}/ratings/${rateId}/rating`,
                {rating, _method: 'patch'},
            );
            commit(SET_RATE, data);
        } catch (e) {
            throw e;
        }
    },
    [UPDATE_RATE_COMMENT]: async (
        {commit},
        {courseId, moduleId, homeWorkId, rateId, comment},
    ) => {
        try {
            const {data} = await $http.post(
                `${process.env.VUE_APP_ROOT_COURSE}courses/${courseId}/modules/${moduleId}/home-works/${homeWorkId}/ratings/${rateId}/comment`,
                {comment, _method: 'patch'},
            );
            commit(SET_RATE, data);
        } catch (e) {
            throw e;
        }
    },
};

const mutations = {
    [SET_ITEM](state, data) {
        state.currentItem = data;
    },
    [CHANGE_LIST_LOADING](state, status) {
        state.isListLoading = status;
    },
    [CHANGE_LOADING](state, status) {
        state.isLoading = status;
    },
    [CHANGE_LOADING_REPORT](state, status) {
        state.isLoadingReport = status;
    },
    [SET_REPORT_RESULT](state, data) {
        state.reportResult = data;
    },
    [CHANGE_STEP](state, number) {
        state.activeStep = number;
    },
    [CHANGE_LOADING_TEST](state, status) {
        state.isLoadingTest = status;
    },
    [CHANGE_HEADER](state, params) {
        state.header = params
    },
    [SET_CURRENT_QUESTION](state, data) {
        state.currentTest = data;
    },
    [CHANGE_POPUP_CANCEL_TEST](state, status) {
        state.showPopupCancel = status;
    },
    [CHANGE_CATEGORY](state, category = '') {
        state.activeCategory = category;
        state.skip = 0;
        state.listLength = 0;
        state.list = [];
    },
    [CHANGE_FROM_ROUTE_INFO](state, info) {
        state.routeFromInfo = info;
    },
    [SET_COMMENT](state, comment) {
        state.comment = comment;
    },
    [SET_RATE](state, {data, changeSummary}) {
        if (changeSummary) {
            modifySummary(state, false);
        }
        state.reportResult.homeWork.data.userRating.data = data.rating === 0 ? [] : data;
        if (changeSummary) {
            modifySummary(state, true);
        }
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
